import React from 'react';
import './LoadingScreen.scss';


const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="terminal-box">
        <div className="scanline" />
        <div className="loader-text">
          <span className="typing">Initializing Khanh's portfolio<span className="blink">|</span></span>
        </div>
        <div className="progress-bar">
          <div className="progress" />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
